angular.module('rjmNg.directives').directive "filterSet", [
  () ->
    restrict: "E"
    templateUrl: "directive.filterSet.html"
    replace: true
    scope:
      restriction: '='
      tableIds: '='
      index: '='
    controller: [
      "$scope"
      "encodedLetterString"
      "FilterSets"
      "app"
      (
        $scope
        encodedLetterString
        FilterSets
        app
      ) ->

        $scope.loading = true
        $scope.filterSets = {}

        $scope.indexToAlpha = encodedLetterString.indexToAlpha

        $scope.getFilterSets = () ->
          $scope.loading = true
          $scope.filterSets = {}

          FilterSets.filterSetsByTableIds(app.getClientId(), $scope.tableIds).then(
            (filterSets) ->
              $scope.filterSets = filterSets
              $scope.loading = false
            , (error) ->
              # TODO: handle error somehow
          )

        $scope.getFilterSets()

    ]
    link: (scope) ->

      scope.$watch 'restriction.filter_set_id', () ->
        scope.$emit('updateIsValid')
        scope.$emit('restrictionChanged')

      scope.$watch 'tableIds', scope.getFilterSets

  ]
